import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

export interface UserDto {
	id: number;
	creationDate: string;
	username: string;
	firstName: string;
	lastName: string;
	email: string;
}

export interface UserUpdateDto {
	id: number;
	firstName?: string;
	lastName?: string;
	email?: string;
}

@Injectable({
	providedIn: 'root'
})
export class AlUserV2Service {
	url: string = 'v2/users';

	constructor(private http: HttpClient) {}

	// CRUD start
	public update(user: UserUpdateDto): Observable<UserDto> {
		return this.http.patch<UserDto>(`${this.url}/${user.id}`, user);
	}

	public delete(userId: number): Observable<void> {
		return this.http.delete<void>(`${this.url}/${userId}`);
	}
	// CRUD end
}
